<template>
  <div class="teachers-table">
    <voxy-table
      id-field="id"
      :columns="columns"
      :rows="teachers"
      :total-rows="count"
      :sortable="true"
      :use-default-order="false"
      :current-page="currentPage"
      :pin-limit="5"
      :display-total-rows="false"
      :ordering="ordering"
      @change:pagesize="changePageSize"
      @change:ordering="changeOrdering"
      @change:currentPage="changeCurrentPage"
    >
      <template #header>
        <div class="teachers-table__tools">
          <SearchBox
            id="lessons-search-box"
            placeholder="Search by keyword"
            v-model="query"
            @search="searchByKeyword"
          />
          <div class="teachers-table__tools__end">
            <teacher-status-filter></teacher-status-filter>
            <availability-filter></availability-filter>
            <language-filter></language-filter>
            <orgs-filter></orgs-filter>
          </div>
        </div>
      </template>

      <template #profile="{ value }">
        <voxy-button size="xs" view="light" @click="goToProfile(value)">Profile</voxy-button>
      </template>

      <template #calendar="{ value }">
        <voxy-button size="xs" view="outlined-invert" @click="goToCalendar(value)">Calendar</voxy-button>
      </template>

      <template #name="{ value }">
        {{ value }}
      </template>

      <template #email="{ value }">
        {{ value }}
      </template>

      <template #group_name="{ value }">
        {{ value }}
      </template>

      <template #teaching_languages="{ value }">
        {{ value.join(', ') }}
      </template>

      <template #availability_upcoming="{ value }">
        {{ value }}
      </template>

      <template #availability_3rd_week="{ value }">
        {{ value }}
      </template>
    </voxy-table>

    <div class="teachers-table__loader" v-if="isFetching">
      <voxy-spinner color="#ffffff" :size="48" :stroke="2"></voxy-spinner>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import { mapWaitingGetters } from 'vue-wait';
import { VoxySpinner, VoxyButton } from '@voxy-team/vue-voxy';

import VoxyTable from '@/components/voxy/VoxyTable';
import SearchBox from '@/components/SearchBox';
import AvailabilityFilter from './AvailabilityFilter';
import OrgsFilter from './OrgsFilter';
import LanguageFilter from './LanguageFilter';
import TeacherStatusFilter from './TeacherStatusFilter';

export default {
  name: 'TeachersTable',

  components: {
    VoxySpinner,
    VoxyTable,
    SearchBox,
    VoxyButton,
    AvailabilityFilter,
    OrgsFilter,
    LanguageFilter,
    TeacherStatusFilter,
  },

  computed: {
    ...mapGetters(['organizationId']),
    ...mapState('manageTeachers', [
      'teachers',
      'count',
      'currentPage',
      'ordering',
      'pageSize',
      'searchKeywords',
      'columns',
    ]),

    ...mapWaitingGetters({
      isFetching: 'teachers.fetching',
    }),

    query: {
      get() {
        return this.searchKeywords;
      },

      set(value) {
        this.setSearchKeyword(value);
      },
    },
  },

  methods: {
    ...mapActions('manageTeachers', {
      changeOrdering: 'CHANGE_ORDERING',
      changeCurrentPage: 'CHANGE_CURRENT_PAGE',
      changePageSize: 'CHANGE_PAGE_SIZE',
      searchByKeyword: 'SEARCH_BY_KEYWORD',
    }),

    ...mapMutations('manageTeachers', {
      setSearchKeyword: 'SET_SEARCH_KEYWORD',
    }),

    goToProfile(teacherHashEmail) {
      this.$router.push({
        name: 'manage_teachers_profile',
        params: {
          teacherHashEmail,
        },
      });
    },

    goToCalendar(teacherHashEmail) {
      this.$router.push({
        name: 'manage_teachers_calendar',
        params: {
          teacherHashEmail,
          orgId: this.organizationId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.teachers-table {
  flex: auto;
  position: relative;

  ::v-deep {
    .voxy-table__wrapper {
      margin-right: -55px;
    }
  }

  &__classes-type {
    font-size: 16px;
  }

  &__loader {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 0;
    right: -55px;
    bottom: 0;
    left: 0;
    margin-top: 15rem;
    background: rgba($night-rider-grey, 0.5);
  }

  &__tools {
    display: grid;
    grid-auto-flow: row;
    gap: 16px;
    justify-content: space-between;

    &__end {
      display: flex;
      gap: 16px;
    }

    @include respond-to(tablet) {
      gap: 32px;
      grid-auto-flow: column;
      grid-template-columns: minmax(160px, 285px) auto;
    }
  }
}
</style>
